/**
 * Geração de CSV (compatível com Excel) e impressão para PDF.
 */

function escaparCelula(v: unknown): string {
  if (v == null) return '';
  const s = String(v);
  if (s.includes('"') || s.includes(';') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export type Tabela = {
  titulo: string;
  cabecalho: string[];
  linhas: Array<Array<string | number>>;
  /**
   * Linha de totais. No CSV sai como última linha da tabela; na impressão A4
   * vira o `<tfoot>` destacado.
   */
  rodape?: Array<string | number>;
  /**
   * Índices das colunas cujo valor é monetário (gravado cru, ex.: `1234.50`).
   * O CSV mantém o número cru — é o que o Excel entende; a impressão formata
   * em R$ e alinha à direita.
   */
  colunasMoeda?: number[];
  /** Índices das colunas numéricas (só alinhamento à direita na impressão). */
  colunasNumero?: number[];
};

export function gerarCsv(tabelas: Tabela[]): string {
  const partes: string[] = [];
  for (const t of tabelas) {
    partes.push(t.titulo);
    partes.push(t.cabecalho.map(escaparCelula).join(';'));
    for (const linha of t.linhas) {
      partes.push(linha.map(escaparCelula).join(';'));
    }
    if (t.rodape) partes.push(t.rodape.map(escaparCelula).join(';'));
    partes.push('');
  }
  // BOM UTF-8 para o Excel reconhecer acentos
  return '﻿' + partes.join('\r\n');
}

export function baixarArquivo(nome: string, conteudo: string, mime: string): void {
  const blob = new Blob([conteudo], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 0);
}

export function exportarCsv(nome: string, tabelas: Tabela[]): void {
  baixarArquivo(`${nome}.csv`, gerarCsv(tabelas), 'text/csv;charset=utf-8');
}

/**
 * Imprime um nó como PDF via window.print() — o usuário escolhe "Salvar como PDF"
 * no diálogo de impressão. Aplica uma classe no body para esconder o resto da UI.
 */
export function imprimirElemento(seletor: string): void {
  const el = document.querySelector(seletor);
  if (!el) {
    window.print();
    return;
  }
  document.body.classList.add('imprimindo');
  el.classList.add('area-impressao');
  const limpar = () => {
    document.body.classList.remove('imprimindo');
    el.classList.remove('area-impressao');
    window.removeEventListener('afterprint', limpar);
  };
  window.addEventListener('afterprint', limpar);
  setTimeout(() => window.print(), 50);
}
